<template>
  <div class="km__modules__productlist km__popup middle">
    <div class="km__popup--heading">
      <button class="km__button--back" type="button" name="back" @click="closeProductList" aria-label="back"></button>
      <button class="km__button--close" type="button" name="close" @click="closeProductList"
              aria-label="close"></button>
      <h2>{{ $t("konf_SelectProdukt") }}</h2>
    </div>
    <div class="km__popup--content">
      <ul class="km__list--modules">
        <li class="km__navi__element"
            v-for="(produkt, index) in currentProducts"
            :key="index"
        >
          <div class="km__product__block" @click="productChosen(produkt.name)">
            <div class="km__product__block--image">
              <img :src="owayoBaseDir+'/newhp/img/'+produkt.imageURL" alt="">
            </div>
            <div class="km__product__block--title">{{ produkt.auwiProductInt }}</div>
            <div class="km__product__block--details">
              <span class="product--details" v-for="(detail, index) in produkt.detailStrings" :key="index">
                {{ detail }}
              </span>
            </div>
            <div class="km__product__block--price">
              <div v-for="(price, index) in produkt.preise" :key="index">
                <span>{{ index }}  {{ $t("Stück") }}: {{ price.grundpreisString }}</span>
              </div>
            </div>
            <button class="km__button--standard">{{ $t("zumProduktKonfi") }}</button>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script lang="ts" setup>
import {useStore} from "vuex";
import {computed, ComputedRef, watch} from "vue";
import gsap from "gsap";

import {OverlayNames} from "@km/store/frontendstate/TabOpenStatusStore";
import {ProduktAuswahlProdukt} from "@km/store/ProduktAuswahlStore";
import {Produktwechsel} from "@km/components/productChange/Produktwechsel";
import globalsObject from "@k/js/globalsObject";


const store = useStore();
watch(() => store.getters.produktListeIsOpen, newValue => {
  if (newValue) {
    gsap.to(".km__modules__productlist", {duration: 0.4, display: "block"})
  } else {
    gsap.to(".km__modules__productlist", {duration: 0.4, display: "none"})
  }
})

function productClicked(productname: string) {
  globalsObject.loopTracker.trackSelectProductEvent(productname);
  Produktwechsel.productChosen(productname);
}


const closeProductList = () => store.commit("SET_OVERLAY_CLOSED", OverlayNames.produktliste);
const owayoBaseDir = import.meta.env.VITE_OWAYO_BASEDIR;
const currentProducts = computed(() => store.getters.getProductsToDisplayAtproductChange) as ComputedRef<ProduktAuswahlProdukt[]>;
const productChosen = (productname: string) => productClicked(productname);


</script>

<style lang="scss" scoped>

.km__modules__productlist {
  display: none;
  z-index: 999;
  overflow-y: auto;
}

.km__product__block {
  width: 300px;
  margin: 40px auto 80px auto;
}

.km__product__block--image {
  margin-bottom: 20px;

  img {
    width: 200px;
  }
}

.km__product__block--title {
  font-weight: 600;
  margin-bottom: 20px;
  font-size: 14px;
  line-height: 1.55em;
}

.km__product__block--details {
  font-size: 14px;
  line-height: 1.55em;
  margin-bottom: 20px;

  .product--details {
    display: block;
  }
}

.km__product__block--price {
  font-size: 14px;
  line-height: 1.55em;
  font-weight: 600;
  margin-bottom: 20px;
}
</style>
